import { USER_STATUS_FILTERS } from "../../pages/Settings/Users/user.utils";

export const UserStatsBar = ({ stats = {}, statusFilter = "all", onStatusFilterChange }) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        <StatCard label="Total users" value={stats.total || 0} />
        <StatCard label="Active" value={stats.active || 0} valueClass="text-green-700" />
        <StatCard label="Inactive" value={stats.inactive || 0} valueClass="text-red-700" />
        <StatCard
          label="No roles assigned"
          value={stats.withoutRoles || 0}
          valueClass="text-amber-700"
        />
      </div>

      <div className="flex flex-wrap gap-2">
        {USER_STATUS_FILTERS.map((filter) => (
          <button
            key={filter.id}
            type="button"
            onClick={() => onStatusFilterChange && onStatusFilterChange(filter.id)}
            className={`rounded-full px-3 py-1 text-sm ${
              statusFilter === filter.id
                ? "bg-primary-100 text-primary-800"
                : "bg-gray-100 text-gray-600 hover:bg-gray-200"
            }`}
          >
            {filter.label}
          </button>
        ))}
    </div>
    </div>
  );
};

function StatCard({ label, value, valueClass = "text-gray-900" }) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4">
      <div className="text-sm font-medium text-gray-500">{label}</div>
      <div className={`mt-1 text-2xl font-semibold ${valueClass}`}>{value}</div>
    </div>
  );
}

export default UserStatsBar;
